module.exports = __webpack_public_path__ + "static/media/pink-pearl.1dd38f79.jpg";